export default __webpack_public_path__ + "static/media/automobiles.505ce631.pdf";